import React from 'react';
import ReactDOM from 'react-dom/client';
import 'src/index.css';
import App from 'src/App';
import store from 'src/redux/store';
import { Provider } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'src/style/global.css';
import 'src/style/font.css';
import 'src/style/theme.scss';
import * as Sentry from '@sentry/react';
import config from 'src/config/config';
import { FontSizeProvider } from 'src/components/FontSizeContext';

const { REACT_APP_NODE_ENV } = process.env;

if (
  process.env.REACT_APP_NODE_ENV === 'production' ||
  process.env.REACT_APP_NODE_ENV === 'staging'
) {
  Sentry.init({
    dsn: 'https://80dd323845e5e605b592226e96d98ab8@sentry.theerpcloud.com/5',
    environment: REACT_APP_NODE_ENV,
    release: `frontend@${config.frontend_version}`,
    integrations: [Sentry.browserTracingIntegration()],
    sendDefaultPii: true,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <div className="main">
    <Provider store={store}>
      <FontSizeProvider>
        <App />
      </FontSizeProvider>
    </Provider>
  </div>,
);

if ('serviceWorker' in navigator) {
  let refreshing = false;

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/serviceWorker.js`;
    navigator.serviceWorker.register(swUrl);
  });
}
